// extracted by mini-css-extract-plugin
export default {"body":"Experience_body__M74we"};